import { defineMessages } from '@transcend-io/internationalization';

export const requiredEnabledAirgapMessages = defineMessages(
  'privacy-center.components.RequiredEnabledAirgap.requiredEnabledAirgap',
  {
    enableAirgap: {
      defaultMessage:
        'This feature requires that you have enabled airgap.js in your Transcend instance. ' +
        'If you are the admin of this account, please go to the ' +
        '"Consent Management" tab, deploy the airgap.js bundle, deploy the privacy center, and try again.',
    },
  },
);
